import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import request from '@/utils/request';
export function merchantList(data) {
  return request.post('admin/payment-merchant/list', data);
}
export const accountBankList = ['中国农业银行', '中国工商银行', '中国建设银行', '中国邮政储蓄银行', '中国银行', '招商银行', '交通银行', '中信银行', '平安银行', '浦发银行', '中国民生银行', '广发银行', '兴业银行', '中国光大银行', '华厦银行', '广东省农村信用社联合社', '云南省农村信用社', '上海银行', '北京银行', '四川省农村信用社联合社', '江苏银行', '南京银行', '中原银行', '山西省农信社', '深圳农村商业银行', '东莞农村商业银行', '长沙银行', '宁波银行', '杭州银行', '桂林银行', '盛京银行', '上海农商银行', '成都银行', '台州银行', '张家口银行', '汉口银行', '河北银行', '兰州银行', '齐鲁银行', '广西北部湾银行', '西安银行', '锦州银行', '莱商银行', '洛阳银行', '绍兴银行', '新韩银行', '富滇银行', '临商银行', '东营银行', '韩亚银行', '徽商银行', '浙江泰隆商业银行', '郑州银行', '安徽省农村信用社', '重庆富民银行', '泰安银行', '承德银行', '烟台银行', '银座村镇银行', '东营莱商村镇银行'];
export function addMerchant(data) {
  return request.post('admin/payment-merchant/store', data);
}
export function editMerchant(data) {
  return request.post('admin/payment-merchant/edit', data);
}
export function merchantDetail(data) {
  return request.post('admin/payment-merchant/detail', data);
}
export function merchantStatus(data) {
  return request.post('admin/payment-merchant/status', data);
}
export function delMerchant(data) {
  return request.post('admin/payment-merchant/delete', data);
}
//商户资源
export function merchantResource(data) {
  return request.post('admin/payment-merchant/resource', data);
}
//发布产品需要的支付回显
export function paymentMethodEcho(data) {
  return request.post('admin/v2/customer-insurance/payment-method-echo', data);
}
export function paymentMethodEcho2(data) {
  return request.post('admin/v2/customer-insurance/payment-method-echo2', data).then(res => {
    res.payList.map(item => {
      item.id = item.merchantId;
      return item;
    });
    return res;
  });
}